import { Injectable, inject } from '@angular/core';
import { OUTLAW_COMMUNITY_CONFIG, OutlawCommunityConfig } from '../../outlaw-community.config';
import { Partner, PartnerApp } from '../../interfaces/partner';
import { COMMUNITY_API_PROVIDER } from '../../providers/community-api.provider';
import { CommunityApiConfig } from '../../interfaces/api/internal-api';

@Injectable({ providedIn: 'root' })
export class CommunityConfigService {
  private config = inject<OutlawCommunityConfig>(OUTLAW_COMMUNITY_CONFIG);
  private apiConfig = inject<CommunityApiConfig>(COMMUNITY_API_PROVIDER);

  get currentApp(): PartnerApp {
    return this.config.currentApp;
  }

  getConfig(): OutlawCommunityConfig {
    return this.config;
  }

  getExternalApi(partner: Partner): string {
    return this.config.externalApi[partner];
  }

  get internalApi(): Partial<CommunityApiConfig> {
    return this.apiConfig;
  }
}
